import axiosHttp from '../hooks/intercepter';
const BASE_URL = process.env.REACT_APP_BASE_URL;

const createCaterer = async (catererData) => {
    return await axiosHttp.post(`${BASE_URL}/caterers`, catererData);
};

const getCatererById = async (id) => {
    return await axiosHttp.get(`${BASE_URL}/caterers/${id}`);
};

const getCaterers = async () => {
    return await axiosHttp.get(`${BASE_URL}/caterers`);
};

const updateCaterer = async (id, catererData) => {
    return await axiosHttp.put(`${BASE_URL}/caterers/${id}`, catererData);
};

const deleteCaterer = async (id) => {
    return await axiosHttp.delete(`${BASE_URL}/caterers/${id}`);
};

const uploadCatererLogo = async (catererId, logoFile) => {
    const formData = new FormData();
    formData.append('logo', logoFile);
    return await axiosHttp.post(`${BASE_URL}/caterers/${catererId}/logo`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

export { createCaterer, getCatererById, getCaterers, updateCaterer, deleteCaterer, uploadCatererLogo }; 